import auth from '../../api/auth'

import {
  ACTIVATION_BEGIN,
  ACTIVATION_CLEAR,
  ACTIVATION_FAILURE,
  ACTIVATION_SUCCESS,
  REGISTRATION_BEGIN,
  REGISTRATION_CLEAR,
  REGISTRATION_FAILURE,
  REGISTRATION_SUCCESS
} from '../types'

export default {
  namespaced: true,
  state: {
    activationCompleted: false,
    activationError: false,
    activationLoading: false,
    registrationCompleted: false,
    registrationError: false,
    registrationLoading: false
  },
  actions: {
    createPreAccount ({commit}, data) {
      return auth.createPreAccount(data)
        .then(() => commit(REGISTRATION_SUCCESS))
        .catch(() => commit(REGISTRATION_FAILURE))
    },
    createAccount ({commit}, data) {
      commit(REGISTRATION_BEGIN)
      return auth.createAccount(data)
        .then((d) => {
          commit(REGISTRATION_SUCCESS)
        })
        .catch((e) => {
          if (e.response.data.error_message) {
            alert(e.response.data.error_message)
          } else {
            commit(REGISTRATION_FAILURE)
          }
        })
    },
    createProfileData ({commit}, data) {
      return auth.createProfileData(data)
    },
    activateAccount ({commit}, {key}) {
      console.debug('*** Start *** activateAccount')
      console.debug('key: ' + JSON.stringify(key))
      commit(ACTIVATION_BEGIN)
      console.debug('*** End *** activateAccount')
      return auth.verifyAccountEmail(key)
        .then(() => commit(ACTIVATION_SUCCESS))
        .catch(() => commit(ACTIVATION_FAILURE))
    },
    clearRegistrationStatus ({commit}) {
      console.debug('*** Start *** clearRegistrationStatus')
      commit(REGISTRATION_CLEAR)
      console.debug('*** End *** clearRegistrationStatus')
    },
    clearActivationStatus ({commit}) {
      console.debug('*** Start *** clearActivationStatus')
      commit(ACTIVATION_CLEAR)
      console.debug('*** End *** clearActivationStatus')
    }
  },
  mutations: {
    [ACTIVATION_BEGIN] (state) {
      console.debug('*** Start *** ACTIVATION_BEGIN')
      console.debug('state: ' + JSON.stringify(state))
      state.activationLoading = true
      console.debug('*** End *** ACTIVATION_BEGIN')
    },
    [ACTIVATION_CLEAR] (state) {
      console.debug('*** Start *** ACTIVATION_CLEAR')
      console.debug('state: ' + JSON.stringify(state))
      state.activationCompleted = false
      state.activationError = false
      state.activationLoading = false
      console.debug('*** End *** ACTIVATION_CLEAR')
    },
    [ACTIVATION_FAILURE] (state) {
      console.debug('*** Start *** ACTIVATION_FAILURE')
      console.debug('state: ' + JSON.stringify(state))
      state.activationError = true
      state.activationLoading = false
      console.debug('*** End *** ACTIVATION_FAILURE')
    },
    [ACTIVATION_SUCCESS] (state) {
      console.debug('*** Start *** ACTIVATION_SUCCESS')
      console.debug('state: ' + JSON.stringify(state))
      state.activationCompleted = true
      state.activationError = false
      state.activationLoading = false
      console.debug('*** End *** ACTIVATION_SUCCESS')
    },
    [REGISTRATION_BEGIN] (state) {
      console.debug('*** Start *** REGISTRATION_BEGIN')
      console.debug('state: ' + JSON.stringify(state))
      state.registrationLoading = true
      console.debug('*** End *** REGISTRATION_BEGIN')
    },
    [REGISTRATION_CLEAR] (state) {
      console.debug('*** Start *** REGISTRATION_CLEAR')
      console.debug('state: ' + JSON.stringify(state))
      state.registrationCompleted = false
      state.registrationError = false
      state.registrationLoading = false
      console.debug('*** End *** REGISTRATION_CLEAR')
    },
    [REGISTRATION_FAILURE] (state) {
      console.debug('*** Start *** REGISTRATION_FAILURE')
      console.debug('state: ' + JSON.stringify(state))
      state.registrationError = true
      state.registrationLoading = false
      console.debug('*** End *** REGISTRATION_FAILURE')
    },
    [REGISTRATION_SUCCESS] (state) {
      console.debug('*** Start *** REGISTRATION_SUCCESS')
      console.debug('state: ' + JSON.stringify(state))
      state.registrationCompleted = true
      state.registrationError = false
      state.registrationLoading = false
      console.debug('*** End *** REGISTRATION_SUCCESS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/signup.js